export default __webpack_public_path__ + "static/media/macneil.591da8e0.svg";